import { Link } from "react-router-dom";

import { cn } from "@/lib/utils";

export function Logo({ className }: { className?: string }) {
  return (
    <Link to="/" className={cn(className)}>
      <img alt="ClassView" src="/logo.svg" className="h-8 w-auto dark:hidden" />
      <img
        alt="ClassView"
        src="/logo-dark.svg"
        className="hidden h-8 w-auto dark:block"
      />
    </Link>
  );
}
